import "styles/profile/rewards.less";

import { useState } from "react";

import LottieAnimation from "components/basic/Spinner/Lottie";

export default function ReferralReward() {
    const [iframeLoaded, setIframeLoaded] = useState(false);

    return (
        <div className={"referral-reward"}>
            {!iframeLoaded && (
                <div>
                    <LottieAnimation isLoading />
                </div>
            )}
            <iframe
                src="https://taxzap.referralrock.com/v2/1"
                width="100%"
                height="100%"
                frameBorder={0}
                style={{ border: "none" }}
                title="Referral Program"
                onLoad={() => setIframeLoaded(true)}
            />
        </div>
    );
}
